export const  LOCATIONS_DATA_REQ = "LOCATIONS_DATA_REQ"
export const  LOCATIONS_DATA_SUCC = " LOCATIONS_DATA_SUCC"
export const  LOCATIONS_DATA_NEW_SUCC = " LOCATIONS_DATA_NEW_SUCC"
export const  LOCATIONS_DATA_FAIL = "LOCATIONS_DATA_FAIL"
export const  LOCATIONS_PAGE_UPDATE = "LOCATIONS_PAGE_UPDATE"
export const  LOCATIONS_DATA_UPDATE = " LOCATIONS_DATA_UPDATE"
export const  LOCATIONS_SORT_UPDATE = "LOCATIONS_SORT_UPDATE"
export const  USER_LOGIN_FLOW = "USER_LOGIN_FLOW"

export const  LOCATIONS_DATA_END = "LOCATIONS_DATA_END"